/* 
 Place holder until all code is moved to modules
*/
import enhancer from '../components/enhancer';

export default enhancer;



// WEBPACK FOOTER //
// ./src/modules/enhancer.js